import { HttpInterceptorFn } from '@angular/common/http';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {

  if (request.url.includes('/onboarding/') &&
      !request.url.includes('/onboarding/operators/')) {
    return next(request);
  }

  const accessToken = localStorage.getItem('access_token');
  if (accessToken !== null) {
    request = request.clone({
      setHeaders: {
        Authorization: 'Bearer ' + accessToken
      }
    });
  }
  return next(request);
};
